import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheck, faCircleInfo, faShieldHalved, faWallet } from '@fortawesome/free-solid-svg-icons';

export default function FluxopayConfigTab() {
  const navigate = useNavigate();
  const steps = [
    ['Conta digital', 'Ativação sujeita à análise'],
    ['Provedor inicial', 'Asaas'],
    ['Recebimentos', 'Pix e cartão'],
    ['Divisão automática', 'Split entre clínica e Fluxopay'],
  ];

  return <div style={{ maxWidth: 920 }}>
    <section style={{
      padding: '26px', borderRadius: 16, color: '#fff',
      background: 'linear-gradient(125deg, #0d3448 0%, #0d796b 120%)',
      boxShadow: '0 14px 32px rgba(14, 68, 79, .16)',
      display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 24, flexWrap: 'wrap',
    }}>
      <div style={{ maxWidth: 580 }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12, fontWeight: 700, color: '#9ff1d9' }}>
          <FontAwesomeIcon icon={faWallet}/> FLUXOPAY
        </span>
        <h3 style={{ fontSize: 23, margin: '9px 0 6px', fontWeight: 750 }}>Recebimentos integrados à rotina da clínica</h3>
        <p style={{ margin: 0, color: '#c6dcdf', fontSize: 13, lineHeight: 1.6 }}>
          Centralize os pagamentos dos agendamentos, acompanhe taxas, recebíveis e repasses sem sair do Fluxo Clínica.
        </p>
      </div>
      <button type="button" onClick={() => navigate('/fluxopay')} style={{
        border: 0, borderRadius: 10, background: '#28d2a5', color: '#083d32',
        padding: '12px 17px', fontWeight: 750, display: 'flex', alignItems: 'center', gap: 9,
      }}>
        Abrir painel Fluxopay <FontAwesomeIcon icon={faArrowRight}/>
      </button>
    </section>

    <section style={{ marginTop: 18, padding: 22, background: '#fff', border: '1px solid #e2eaee', borderRadius: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 13 }}>
        <div><small style={{ color: '#80909a', fontWeight: 700 }}>ONBOARDING FLUXOPAY</small><h4 style={{ fontSize: 16, margin: '3px 0 0' }}>Conta digital e recebimentos integrados</h4></div>
        <span style={{ padding: '5px 9px', borderRadius: 20, background: '#e9f9f3', color: '#087c60', fontSize: 11, fontWeight: 700 }}>Asaas</span>
      </div>
      {steps.map(([title, value]) => <div key={title} style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '12px 2px', borderTop: '1px solid #edf2f4' }}>
        <span style={{ width: 27, height: 27, borderRadius: '50%', background: '#e8faf4', color: '#078265', display: 'grid', placeItems: 'center', fontSize: 10 }}><FontAwesomeIcon icon={faCheck}/></span>
        <b style={{ flex: 1, fontSize: 13, color: '#294451' }}>{title}</b><span style={{ fontSize: 12, color: '#73848e' }}>{value}</span>
      </div>)}
      <p style={{ display: 'flex', gap: 8, margin: '14px 0 0', padding: 11, borderRadius: 9, background: '#f4f8fa', color: '#687c88', fontSize: 11 }}>
        <FontAwesomeIcon icon={faShieldHalved}/><span>O Representante Legal pode solicitar a ativação. A subconta será criada somente após revisão administrativa.</span>
      </p>
    </section>

    <p style={{ marginTop: 15, color: '#7b8b94', fontSize: 11 }}><FontAwesomeIcon icon={faCircleInfo} style={{ marginRight: 7 }}/>Acesse o painel para revisar os dados empresariais e acompanhar o status da solicitação.</p>
  </div>;
}
